import { render } from "./specialPoojaList.vue?vue&type=template&id=b98c0fb4"
import script from "./specialPoojaList.vue?vue&type=script&lang=js"
export * from "./specialPoojaList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__